<div class="min-vh-100 bg-light d-flex flex-column">
  <!-- Encabezado Hero -->
  <div class="bg-success text-white py-4 shadow-sm">
    <div class="container d-flex justify-content-between align-items-center">
      <div>
        <h2 class="fw-bold mb-1">¡Bienvenido/a {{ userName || 'Usuario' }}!</h2>
        <p class="mb-0 small">Gestioná tu TiendApp de forma sencilla y efectiva</p>
        <i class="fa-solid fa-circle-info" title="Guía Rápida" style="cursor: pointer;" (click)="empezarGuia()"></i>
      </div>
     
      <div id="menu" class="dropdown">
        <button class="btn btn-outline-light rounded-pill px-3 dropdown-toggle" type="button" id="userMenu" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="fa-solid fa-user me-2"></i>{{ userName || 'Usuario' }}
        </button>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userMenu">
          <li>
            <a class="dropdown-item" routerLink="/cambiar-password">
              <i class="fa-solid fa-key me-2"></i>Cambiar contraseña
            </a>
          </li>
          <li><hr class="dropdown-divider"></li>
          <li>
            <button class="dropdown-item text-danger" data-bs-toggle="modal" data-bs-target="#logoutModal">
              <i class="fa-solid fa-right-from-bracket me-2"></i>Cerrar sesión
            </button>
          </li>
          <!-- <li><hr class="dropdown-divider"></li>
          <li>
            <button class="btn btn-outline-secondary ms-2" (click)="toggleTheme()">
              <i class="fa" [ngClass]="isDark ? 'fa-sun' : 'fa-moon'"> {{textMode}}</i>
            </button>
          </li> -->
        </ul>
      </div>
     

    </div>
  </div>

  <!-- Modal logout -->
  <div class="modal fade" id="logoutModal" tabindex="-1" aria-labelledby="logoutModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="logoutModalLabel">Confirmar cierre de sesión</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
        </div>
        <div class="modal-body">
          ¿Estás seguro de que querés cerrar sesión?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" (click)="confirmLogout()" data-bs-dismiss="modal">Cerrar sesión</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Cards del dashboard -->
  <div class="container my-5">
    <div class="row g-4">
      <div class="col-12 col-md-6">
        <div class="card shadow-sm border-0 h-100">
          <div id ="clientes" class="card-body text-center">
            <i class="fa-solid fa-users fa-3x text-primary mb-3"></i>
            <h5 class="card-title fw-bold">Clientes</h5>
            <p class="card-text">Administrá tus clientes y sus deudas.</p>
            <a class="btn btn-outline-primary w-100" routerLink="/cliente">Ver clientes</a>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="card shadow-sm border-0 h-100">
          <div id ="productos" class="card-body text-center">
            <i class="fa-solid fa-box-open fa-3x text-success mb-3"></i>
            <h5 class="card-title fw-bold">Productos</h5>
            <p class="card-text">Gestioná productos vendidos a crédito.</p>
            <a class="btn btn-outline-success w-100" routerLink="/productos">Ver productos</a>
          </div>
        </div>
      </div>

      
    </div>
  </div>
</div>
